var map = {
	"./2018-05-darknet/video.webm": 317,
	"./2018-09-das-steckt-drin/video.webm": 318,
	"./2019-02-abend-kompakt/video.webm": 319,
	"./2019-02-quiz-geldwaescherei/video.webm": 320,
	"./2019-03-staedtequiz/video.webm": 321,
	"./2019-04-zuercher-laufrouten/video.webm": 322,
	"./2019-07-klimazukunft/video.webm": 323,
	"./2019-08-5g-faktencheck/alt/video.webm": 324,
	"./2019-08-5g-faktencheck/video.webm": 325,
	"./2019-09-sommerbilanz/video.webm": 326,
	"./2019-10-prognose-staenderatswahlen/video.webm": 327,
	"./2019-12-schneetage/video.webm": 328,
	"./2020-02-lohnvergleich/video.webm": 329,
	"./2020-02-winterbilanz/winterbilanz.webm": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 316;